import { ApplicationConfig, inject, provideAppInitializer, provideBrowserGlobalErrorListeners, provideZoneChangeDetection, ErrorHandler } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideOptimus } from '@openng/optimus-ui/config';
import Aura from '@openng/optimus-ui-themes/aura';
import { definePreset } from '@openng/optimus-ui-themes';
import { authInterceptor } from './core/interceptors/auth.interceptor.functional';
import { GlobalErrorHandler } from './core/services/error-handler.service';
import { MessageService } from '@openng/optimus-ui/api';
import { LoggerService } from './core/services/logger.service';
import { PerformanceService } from './core/services/performance.service';
import { ReleasesSignalrService } from './core/services/releases-signalr.service';

import { routes } from './app.routes';

const BlueAura = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '{blue.400}',
      500: '{blue.500}',
      600: '{blue.600}',
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}'
    }
  }
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withXhr(), withInterceptors([authInterceptor])),
    provideAnimationsAsync(),
    provideOptimus({
      theme: {
        preset: BlueAura,
        options: {
          prefix: 'p',
          // Not 'system': the app has no dark palette of its own, so following the OS turned
          // Optimus components dark inside light page chrome.
          darkModeSelector: '.app-dark',
          cssLayer: false
        }
      }
    }),
    MessageService,
    LoggerService,
    PerformanceService,
    provideAppInitializer(() => {
      inject(ReleasesSignalrService).startConnection();
    }),
    { provide: ErrorHandler, useClass: GlobalErrorHandler }
  ]
};
